import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EvaluationVehicle } from '@app-model/evaluation';

@Component({
  selector: 'app-evaluation-fill-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './evaluation-fill-progress-bar.component.html',
  styleUrls: ['./evaluation-fill-progress-bar.component.scss'],
})
export class EvaluationFillProgressBarComponent {
  readonly vehicle = input.required<EvaluationVehicle>();
  readonly mode = input<'card' | 'detail'>('detail');


  getTotalEvalFilled(): number {
    const v = this.vehicle();
    const raw = Number(v?.totalEvalFilled ?? 0);
    
    if (!Number.isFinite(raw)) {
      return 0;
    }
    return Math.min(Math.max(raw, 0), 100);
  }

  getProgressWidth(): number {
    return this.getTotalEvalFilled();
  }

  getProgressClass(): string {

    const t = this.getTotalEvalFilled();
    if (t <= 20) {
      return 'is-range-1';
    }
    if (t <= 40) {
      return 'is-range-2';
    }
    if (t <= 60) {
      return 'is-range-3';
    }
    if (t <= 80) {
      return 'is-range-4';
    }
    return 'is-range-5';
  }

  formatPercentage(value: number): string {
    return value.toLocaleString('pt-BR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
}